const state = {
    category_id: 0,
    order_status: {
        id: '',
        title: '不限'
    }
}
export default{
    state
}